import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class currenyMaskService {
    amountPrecisionOptions = {
        align: 'right',
        allowNegative: false,
        allowZero: true,
        decimal: ',',
        precision: 2,
        prefix: '',
        suffix: '',
        thousands: '.'
    };
    ratePrecisionOptions = {
        align: 'right',
        allowNegative: false,
        allowZero: true,
        decimal: ',',
        precision: 4,
        prefix: '',
        suffix: '',
        thousands: '.'
    };

    strikeRatePrecisionOptions = {
        align: 'right',
        allowNegative: false,
        allowZero: true,
        decimal: ',',
        precision: 1,
        prefix: '',
        suffix: '',

        thousands: '.'
    };

    constructor() {}
}
